import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-fields" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "_mt-3 _tac" }
const _hoisted_4 = { class: "_mt-3 _tac" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  class: "_mt-3 _tac",
  "data-qa": "login-form:AlreadyHaveAnAccountLogInLink"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  class: "_mt-3 _tac",
  "data-qa": "login-form:ForgotPassword"
}
const _hoisted_9 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_localize = _resolveComponent("localize")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("fieldset", null, [
        _createVNode(_component_field, {
          name: "model.email",
          "display-name": _ctx.Resources.Account.EmailFieldLabel,
          "data-qa": "create-account:email"
        }, {
          default: _withCtx(({ fieldId }) => [
            _withDirectives(_createElementVNode("input", {
              id: fieldId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.email) = $event)),
              class: "gfu-field__input",
              type: "email",
              name: "email",
              onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers((...args) => ($options.onSubmit && $options.onSubmit(...args)), ["prevent","stop"]), ["enter"])),
              "data-qa": "text-field-input"
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2), [
              [_vModelText, $data.model.email]
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["display-name"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_field, null, {
            default: _withCtx(() => [
              _createVNode(_component_base_button, {
                type: "submit",
                width: "wide",
                theme: "accent",
                onClick: _withModifiers($options.onSubmit, ["prevent"]),
                "data-qa": "create-account-button:Continue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Account.ContinueActionButton), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_localize, {
            resource: _ctx.Resources.Account.SignUpConsequenceIntroParagraph
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                "format-key": "0",
                href: $options.privacyPolicyUrl,
                class: "gfu-link gfu-link--accent",
                "data-qa": "create-account:PrivacyPolicy"
              }, _toDisplayString(_ctx.Resources.Account.SignUpConsequencePrivacyPolicyLink), 9 /* TEXT, PROPS */, _hoisted_5)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            href: $options.loginUrl,
            class: "gfu-link gfu-link--accent"
          }, _toDisplayString(_ctx.Resources.Account.LogInLink), 9 /* TEXT, PROPS */, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("a", {
            href: $options.resetPasswordUrl,
            class: "gfu-link gfu-link--accent"
          }, _toDisplayString(_ctx.Resources.Account.ForgotPasswordLink), 9 /* TEXT, PROPS */, _hoisted_9)
        ])
      ])
    ]),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}